import { Component, Input } from '@angular/core';
import { UtlPerFinService } from '../../utl-per-fin.service';

@Component({
  selector: 'table-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.css']
})
export class MainHeaderComponent {
  @Input() headerData;
  @Input() firstSectionDisplayed;
  @Input() topLevelHeaderToDisplay;
  @Input() isMobile;
  @Input() columnHeader;

  constructor(private utlPerFinService: UtlPerFinService) {}

  userRequestsNextColumns() {
    this.utlPerFinService.horizontalScrollTableColumns.emit('next');
  }

  userRequestsLastColumns() {
    this.utlPerFinService.horizontalScrollTableColumns.emit('last');
  }
}



// WEBPACK FOOTER //
// ./src/app/t8-utl-per-fin/components-utl-per-fin/main-header/main-header.component.ts